import { createAction } from '@ngrx/store';

export const triggerDropboxAuthDialog = createAction('[Dropbox] Trigger Auth Dialog');
